import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  BANNERS_ADD_PATH,
  BANNERS_PATH,
  BANNERS_UPDATE_PATH,
} from "utils/constants/paths";

const Banners = Loadable(React.lazy(() => import("./View")));
const BannersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const BannersRoute: IRouteItem = {
  path: BANNERS_PATH,
  iconName: "Image",
  element: React.createElement(Banners),
  name: "Banners",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: BANNERS_ADD_PATH,
      element: React.createElement(BannersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: BANNERS_UPDATE_PATH,
      element: React.createElement(BannersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
